<template>
  <v-card>
    <v-card-title primary-title>
      OPE
      <v-spacer></v-spacer>
      <div class="d-flex">
        <v-btn icon @click="$emit('open-dialog', 'production')">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-icon v-on="on" v-bind="attrs">mdi-factory</v-icon>
            </template>
            Show Shift Production
          </v-tooltip>
        </v-btn>
        <v-btn icon @click="$emit('open-dialog', 'downtime')">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-icon v-on="on" v-bind="attrs">mdi-clock-alert</v-icon>
            </template>
            Show Shift Downtime
          </v-tooltip>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-text class="text-center" v-if="thisShiftSummary ">
      <v-progress-circular size="180"
       :value="thisShiftOee" button width="15" color="primary" rotate="-90">
        <div class="display-1">
          {{ opePer + '%' }}
        </div>
        <div>
        </div>
      </v-progress-circular>
      <div class="headline mt-2">
        OPE
      </div>
      <v-tabs grow center-active show-arrows class="mt-4" v-model="tab" icons-and-text>
        <v-tab class="text-none custom-font">
          Utilization
          <span class="headline font-weight-medium">
            {{ totalUtilizationCal + `%` }}
          </span>
        </v-tab>
        <v-tab class="text-none custom-font">
          Cycle Time Efficiency
          <span class="headline font-weight-medium">
            {{ cycleTime + `%` }}
          </span>
        </v-tab>
        <v-tab class="text-none custom-font">
          OPE
          <span class="headline font-weight-medium">
            {{ opePer + '%' }}
          </span>
        </v-tab>
      </v-tabs>
      <v-row v-if="tab === 0">
        <v-col cols="12">
          <v-card :class="{ 'fullscreen-card': fullScreenCard === 'MachineWiseUtilization' }"
            :style="fullScreenCard === 'MachineWiseUtilization' ? {} : { height: '500px' }"
            data-card-id="MachineWiseUtilization">
            <v-btn v-if="!fullScreenCard || fullScreenCard === 'MachineWiseUtilization'" icon
              class="fullscreen-toggle" @click="toggleFullscreen('MachineWiseUtilization')">
              <v-icon>
                {{ fullScreenCard === 'MachineWiseUtilization' ? 'mdi-arrow-collapse' :
                 'mdi-arrow-expand' }}
              </v-icon>
            </v-btn>
            <MachineWiseUtilization :thisMachines="thisShiftSummarynew.resultgetFilteredMachines"
              ref="MachineWiseUtilization" />
          </v-card>
        </v-col>
        <v-col cols="12" v-if="downtimeByMachine">
          <v-card :class="{ 'fullscreen-card': fullScreenCard === 'downtime' }"
            :style="fullScreenCard === 'downtime' ? {} :
             { height: '500px' }" data-card-id="downtime">
            <v-btn v-if="!fullScreenCard || fullScreenCard === 'downtime'"
             icon class="fullscreen-toggle"
              @click="toggleFullscreen('downtime')">
              <v-icon>
                {{ fullScreenCard === 'downtime' ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}
              </v-icon>
            </v-btn>
            <div ref="downtimeChartContainer" style="width: 100%; height: 100%;">
              <highcharts class="mt-4" ref="downtimeChartRef" :options="downtimeByMachineOptions"
                style="width: 100%; height: 100%;" />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else-if="tab === 1">
        <v-col cols="12">
          <v-card :class="{ 'fullscreen-card': fullScreenCard === 'CycleTimeDurationInMin' }"
            :style="fullScreenCard === 'CycleTimeDurationInMin' ? {} : { height: '500px' }"
            data-card-id="CycleTimeDurationInMin">
            <v-btn v-if="!fullScreenCard || fullScreenCard ===
             'CycleTimeDurationInMin'" icon class="fullscreen-toggle"
              @click="toggleFullscreen('CycleTimeDurationInMin')">
              <v-icon>
                {{ fullScreenCard === 'CycleTimeDurationInMin' ?
                 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}
              </v-icon>
            </v-btn>

            <CycleTimeDurationInMin :thisMachines="thisCycleTimeAnalysis.convertedData"
              ref="performance-comparisionChartRef" />
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card :class="{ 'fullscreen-card': fullScreenCard === 'MachineCycleTable' }"
            :style="fullScreenCard === 'MachineCycleTable' ? {} :
             { height: '500px' }" data-card-id="MachineCycleTable">
            <v-btn v-if="!fullScreenCard || fullScreenCard === 'MachineCycleTable'"
             icon class="fullscreen-toggle"
              @click="toggleFullscreen('MachineCycleTable')">
              <v-icon>
                {{ fullScreenCard === 'MachineCycleTable' ?
                 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}
              </v-icon>
            </v-btn>

            <MachineCycleTable ref="MachineCycleTableRef" />
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="tab === 2">
        <v-col cols="12">
          <v-card :class="{ 'fullscreen-card': fullScreenCard === 'CumulativeOpe' }"
            :style="fullScreenCard === 'CumulativeOpe' ? {} : { height: '500px' }"
            data-card-id="CumulativeOpe">
            <v-btn v-if="!fullScreenCard ||
             fullScreenCard === 'CumulativeOpe'" icon class="fullscreen-toggle"
              @click="toggleFullscreen('CumulativeOpe')">
              <v-icon>
                {{ fullScreenCard === 'CumulativeOpe' ? 'mdi-arrow-collapse' :
                 'mdi-arrow-expand' }}
              </v-icon>
            </v-btn>

            <CumulativeOpe
            :thisMachines="thisTargetActualc.updatedResultFilteredMachinescycletime"
             ref="quality-comparisionChartRef" />
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card :class="{ 'fullscreen-card': fullScreenCard === 'shiftwise' }"
            :style="fullScreenCard === 'shiftwise' ? {} : { height: '500px' }"
             data-card-id="shiftwise">
            <v-btn v-if="!fullScreenCard || fullScreenCard === 'shiftwise'" icon
             class="fullscreen-toggle"
              @click="toggleFullscreen('shiftwise')">
              <v-icon>
                {{ fullScreenCard === 'shiftwise' ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}
              </v-icon>
            </v-btn>

            <shiftwise :thisMachines="thisTargetproduceShift.updatedResultShiftwise"
             ref="shiftwiseChartRef" />
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card :class="{ 'fullscreen-card': fullScreenCard === 'CumulativeProductionCount' }"
            :style="fullScreenCard === 'CumulativeProductionCount' ? {} :
             { height: '500px' }" data-card-id="CumulativeProductionCount">
            <v-btn v-if="!fullScreenCard || fullScreenCard ===
             'CumulativeProductionCount'" icon class="fullscreen-toggle"
              @click="toggleFullscreen('CumulativeProductionCount')">
              <v-icon>
                {{ fullScreenCard === 'CumulativeProductionCount' ?
                 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}
              </v-icon>
            </v-btn>

            <CumulativeProductionCount
             :thisMachines="thisTargetActual.resultFilteredMachinescycletime"
             ref="TaegerActualChartRef" />
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card :class="{ 'fullscreen-card': fullScreenCard === 'ShiftWiseProductionCount' }"
            :style="fullScreenCard === 'ShiftWiseProductionCount' ? {} :
             { height: '500px' }" data-card-id="ShiftWiseProductionCount">
            <v-btn v-if="!fullScreenCard || fullScreenCard ===
             'ShiftWiseProductionCount'" icon class="fullscreen-toggle"
              @click="toggleFullscreen('ShiftWiseProductionCount')">
              <v-icon>
                {{ fullScreenCard === 'ShiftWiseProductionCount' ?
                'mdi-arrow-collapse' : 'mdi-arrow-expand' }}
              </v-icon>
            </v-btn>
            <ShiftWiseProductionCount
            :thisMachines="thisTargetproduceculu.resultFilteredMachinesShiftwiseOpe"
             ref="cumulativeChartRef" />
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else-if="loading">
      <v-container fill-height>
        <v-row align="center" justify="center" :no-gutters="$vuetify.breakpoint.smAndDown">
          <v-col cols="12" align="center">
            <v-progress-circular indeterminate color="primary" size="72"></v-progress-circular>
          </v-col>
          <v-col cols="12" align="center">
            <span class="headline">
              {{ $t('fetchingOee') }}
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-text v-else>
      <v-container fill-height>
        <v-row align="center" justify="center" :no-gutters="$vuetify.breakpoint.smAndDown">
          <v-col cols="5" align="center">
            <v-img :src="require(`@shopworx/assets/illustrations/${notFoundIllustration}.svg`)"
             contain />
          </v-col>
          <v-col cols="12" align="center">
            <span class="headline">
              {{ $t('noRecordsOee') }}
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from 'vuex';
import MachineWiseUtilization from './oee/MachineWiseUtilization.vue';
import CycleTimeDurationInMin from './oee/CycleTimeDurationInMin.vue';
import CumulativeOpe from './oee/CumulativeOpe.vue';
import CumulativeProductionCount from './oee/CumulativeProductionCount.vue';
import MachineCycleTable from './oee/MachineCycleTable.vue';
import shiftwise from './oee/shiftwise.vue';
import ShiftWiseProductionCount from './oee/ShiftWiseProductionCount.vue';

export default {
  name: 'OeeSummary',
  components: {
    MachineWiseUtilization,
    CycleTimeDurationInMin,
    CumulativeOpe,
    CumulativeProductionCount,
    MachineCycleTable,
    shiftwise,
    ShiftWiseProductionCount,
  },
  data() {
    return {
      fullScreenCard: null,
      tab: 2,
      downtimeByMachineOptions: {},
    };
  },
  computed: {
    ...mapState('helper', ['isDark']),
    ...mapState('kpiDashboard', [
      'loading',
      'cycleTime',
      'thisShiftSummary',
      'opePer',
      'thisShiftSummarynew',
      'thisTargetActual',
      'thisTargetActualc',
      'downtimeByMachine',
      'productionByMachine',
      'thisCycleTimeAnalysis',
      'thisTargetproduceShift',
      'thisTargetproduceculu',
      'totalUtilizationCal',
    ]),
    notFoundIllustration() {
      return this.$vuetify.theme.dark
        ? 'not-found-dark'
        : 'not-found-light';
    },

    thisShiftOee() {
      return (this.thisShiftSummary && this.thisShiftSummary.oee) || 0;
    },
    thisShiftOeeText() {
      return `${this.roundOff(this.thisShiftOee)}%`;
    },
  },
  methods: {
    roundOff(val) {
      if (val) {
        return Math.round((val + Number.EPSILON) * 100) / 100;
      }
      return 0;
    },
    toggleFullscreen(card) {
      if (this.fullScreenCard === card) {
        this.fullScreenCard = null;
      } else {
        this.fullScreenCard = card;
        this.$nextTick(() => {
          // Resize Highcharts
          this.$refs.shiftwiseChartRef?.reflowChart?.();
          this.$refs['quality-comparisionChartRef']?.reflowChart?.();
          this.$refs.downtimeChartRef?.chart?.reflow?.();

          // Resize AG Grid
          if (card === 'MachineCycleTable') {
            const component = this.$refs.MachineCycleTableRef;
            component?.gridApi?.doLayout?.();
          }
        });
      }
    },
    setOptions(options) {
      const opt = { ...options };
      opt.title.style = {};
      opt.title.text = this.$t(`${options.title.text}`);
      opt.title.style.color = this.isDark ? '#FFFFFF' : '#333333';
      opt.yAxis = options.yAxis.map((axis) => {
        const labels = {
          style: { color: this.isDark ? '#FFFFFF' : '#666666' },
        };
        if (axis.labels) {
          return { ...axis, labels: { ...axis.labels, ...labels } };
        }
        return {
          ...axis,
          labels,
        };
      });
      opt.xAxis.labels = {};
      opt.xAxis.labels.style = {};
      opt.xAxis.labels.style.color = this.isDark ? '#FFFFFF' : '#666666';
      return opt;
    },
  },
  watch: {
    downtimeByMachine(val) {
      this.downtimeByMachineOptions = this.setOptions(val);
    },
    isDark() {
      this.downtimeByMachineOptions = this.setOptions(this.downtimeByMachine);
    },
  },
};
</script>

<style>
.v-progress-circular .v-progress-circular__info {
  display: block;
}

.fullscreen-card {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 9999;
  background: white;
  padding: 20px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
  overflow: auto;
}

.fullscreen-toggle {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10000;
}

.custom-font {
  font-family: 'Poppins', sans-serif;
}
</style>
